export const pageNotFoundProspectusProduitsProps = () => ({
  magasinName: {
    type: String,
    required: true
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  }
})
